import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

// [FORGOT-PASSWORD FEATURE - DEMO] remove this line to roll back
import ForgotPasswordModal from "../components/ForgotPasswordModal";

export default function Login() {
  const [form, setForm] = useState({
    username: "",
    password: "",
  });

  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  // Password visibility
  const [showPassword, setShowPassword] = useState(false);

  // [FORGOT-PASSWORD FEATURE - DEMO] remove this line to roll back
  const [showForgotPassword, setShowForgotPassword] = useState(false);

  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Prevent multiple login submissions
    if (loading) return;

    setError("");
    setLoading(true);

    try {
      const profile = await login(form.username, form.password);

      const isAdmin =
        profile?.is_superuser || profile?.role === "admin";

      const isManager = profile?.role === "manager";

      navigate(
        isAdmin || isManager
          ? "/admin"
          : "/dashboard"
      );
    } catch (err) {
      setError(
        err.response?.data?.detail ||
        "Invalid username or password."
      );

      // Unlock fields if login fails
      setLoading(false);
    }
  };

  return (
    <div
      className="auth-wrapper"
      style={{
        backgroundImage: "url('/bg.png')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        minHeight: "100vh",
        position: "relative",
      }}
    >
      <div className="auth-card">

        <div className="login-branding">

          {/* myG Logo */}
          <img
            src="/myglogotrnsparent.png"
            alt="myG Logo"
            className="myg-login-logo"
          />

          {/* QR Studio Heading Image */}
          <img
            src="/QR-STUDIO.png"
            alt="QR Studio"
            className="qr-studio-heading"
          />

        </div>

        <form onSubmit={handleSubmit}>

          {/* Username */}
          <div className="form-group">
            <input
              className="form-input"
              value={form.username}
              onChange={(e) =>
                setForm({
                  ...form,
                  username: e.target.value.toUpperCase(),
                })
              }
              placeholder="myG ID"
              required
              disabled={loading}
            />
          </div>

          {/* Password */}
          <div className="form-group">
            <div className="password-input-wrapper">
              <input
                type={showPassword ? "text" : "password"}
                className="form-input password-input"
                value={form.password}
                onChange={(e) =>
                  setForm({
                    ...form,
                    password: e.target.value,
                  })
                }
                placeholder="Password"
                required
                disabled={loading}
              />

              <button
                type="button"
                className="password-eye-btn"
                onClick={() => setShowPassword(!showPassword)}
                disabled={loading}
                aria-label={
                  showPassword ? "Hide password" : "Show password"
                }
                title={
                  showPassword ? "Hide password" : "Show password"
                }
              >
                {showPassword ? (
                  /* Eye Off */
                  <svg
                    width="19"
                    height="19"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M3 3l18 18" />
                    <path d="M10.58 10.58a2 2 0 0 0 2.83 2.83" />
                    <path d="M9.88 4.24A9.77 9.77 0 0 1 12 4c5 0 9.27 3.11 11 8a18.5 18.5 0 0 1-3.16 5.19" />
                    <path d="M6.61 6.61C4.62 7.9 3.05 9.73 2 12c1.73 4.89 6 8 10 8a9.75 9.75 0 0 0 3.4-.61" />
                  </svg>
                ) : (
                  /* Eye */
                  <svg
                    width="19"
                    height="19"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12Z" />
                    <circle cx="12" cy="12" r="3" />
                  </svg>
                )}
              </button>
            </div>
          </div>

          {/* Error */}
          {error && (
            <div className="error-text">
              {error}
            </div>
          )}

          {/* Login Button */}
          <button
            type="submit"
            className="btn btn-primary2"
            style={{
              width: "100%",
              marginTop: 8,
            }}
            disabled={loading}
          >
            {loading ? "Signing in..." : "Login"}
          </button>

        </form>

        {/* [FORGOT-PASSWORD FEATURE - DEMO] */}
        <p
          style={{
            fontSize: 13,
            marginTop: 12,
            textAlign: "center",
          }}
        >
          <button
            type="button"
            onClick={() => setShowForgotPassword(true)}
            disabled={loading}
            style={{
              background: "none",
              border: "none",
              color: "var(--myg-red, #E31E24)",
              cursor: loading ? "not-allowed" : "pointer",
              padding: 0,
              font: "inherit",
              textDecoration: "underline",
              opacity: loading ? 0.5 : 1,
            }}
          >
            Forgot password?
          </button>
        </p>

        {/* Register - currently disabled */}
        {/*
        <p
          style={{
            fontSize: 13,
            marginTop: 16,
            textAlign: "center",
          }}
        >
          Don't have an account?{" "}
          <Link to="/register">Register</Link>
        </p>
        */}

      </div>

      {/* [FORGOT-PASSWORD FEATURE - DEMO] */}
      {showForgotPassword && (
        <ForgotPasswordModal
          onClose={() => setShowForgotPassword(false)}
        />
      )}

      {/* Copyright Watermark */}
      <div className="login-copyright">
        © 2026 myG IT Projects. All rights reserved.
      </div>

    </div>
  );
} 